import * as PropTypes from 'prop-types';
export function safePropTypesInstanceOf(expectedClass) {
  return expectedClass ? PropTypes.instanceOf(expectedClass) : PropTypes.any;
}